import React from "react";

const BlogPost = ({ title, featured_image, content }) => {
  return (
    <div className="flex flex-col md:items-center md:content-center">
      <h1 className="text-cyan-500 font-montserrat text-4xl md:text-4xl font-normal my-4 md:my-8">
        {title}
      </h1>
      <img
        className="w-full md:w-2/4 align-center my-4 md:my-8"
        src={featured_image}
        alt={title}
      />
      <div
        className="font-montserrat mt-8 text-black"
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    </div>
  );
};

export default BlogPost;
